import { useState, useEffect, useRef } from 'react';
import { Button, Modal, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";

import plan_img from '../../../../images/subscription/plans.png';
import transaction from '../../../../images/subscription/transaction.png';
import QrCode from '../../../../images/subscription/payments.png';
import $ from "jquery";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addDays, subDays } from 'date-fns';
import { QRCodeSVG } from 'qrcode.react'; 

const SubscriptionPayment = ({ show, onClose, data, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [packagerelation, setpackage] = useState([]);
    const [timelinerelation, settimeline] = useState([]);
    const [subtotal, setsubtotal] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [balance_amount, setBalance] = useState(0);
    
    const [amount, setAmount] = useState(null);
    const [collectedDate, setCollectedDate] = useState(null);

    useEffect (() => { 
        setpackage(data.packagerelation);
        settimeline(data.timelinerelation);
        setAmount(parseFloat(data.balance_amount));
    }, [data]);

    useEffect (() => {
        if (packagerelation && !isNaN(parseFloat(packagerelation.selling_amount))) {
            const sellingAmount = parseFloat(packagerelation.selling_amount);
            setsubtotal(sellingAmount);

            const gstValue = sellingAmount * 0.05;
            setGst(gstValue);

            const total = sellingAmount + gstValue;
            setTotalAmount(total);
        }  else {
            setsubtotal(0);
            setGst(0);
            setTotalAmount(0);
        }
    } , [packagerelation]);

    const [paymentmode, setPaymode] = useState([]);
    const [transactionId, setTransactionId] = useState('');
    const [selectedPayment, setSelectedPayment] = useState(null);
    
    useEffect(() => {
        const fetchpaymode = async () => {
            try {
            const response = await axios.get(`${baseURL}/paymentmode/getactive`);
            const formatted = response.data.map(item => ({
                value: item.sno,
                label: item.paymentmode_name,
                transaction_id: item.transaction_id,
            }));
            setPaymode(formatted);
            } catch (error) {
            console.error('Error fetching lead types:', error);
            }
        };

        fetchpaymode();
    }, []);

    const handlePaymentChange = (selectedOption) => {
        setSelectedPayment(selectedOption.value);
        setIsVisible(selectedOption?.transaction_id === 0); // Show field only if transaction_id is 0
    };

    const [isVisible, setIsVisible] = useState();
    
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const [paymentdatas, setPayData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const fetchData = () => {
        const params = {
            branch_id: branch_id,
            subscription_id: data.subscription_id
        };
        axios.get(`${baseURL}/subscription/payment_details`, { params: params })
            .then(response => {
                setPayData(response.data.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    const fetchBalance = () => {
        const params = {
            branch_id: branch_id,
            subscription_id: data.subscription_id
        };
        axios.get(`${baseURL}/subscription/subs_details`, { params: params })
            .then(response => {
                setBalance(response.data.data.balance_amount);
                setAmount(response.data.data.balance_amount);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    };

    useEffect(() => {
        fetchBalance();
    }, []);

    useEffect(() => {
        if(data.subscription_id) {
            fetchData();
        }
    }, [data])

    const tableRef = useRef(null);

    useEffect(() => {
        const tables = document.querySelectorAll('.subscription_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);
    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [sendVia, setSendVia] = useState('');

    const handleSendViaChange = (e) => {
        setSendVia(e.target.value);
    };

    const handleCollectDateChange = (date) => {
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            // console.log(formattedDate);
            setCollectedDate(formattedDate);
        } else {
            setCollectedDate(null);
        }
    };
    
    useEffect(() => {
        const enteredAmount = parseFloat(amount);
        const maxAmount = parseFloat(data.balance_amount);
        const errors = {};
        if (amount === '') {
            // Clear error if input is empty
            errors.amount = '';
        }

        if (isNaN(enteredAmount)) {
            errors.amount = 'Invalid amount';
        }

        if (enteredAmount > maxAmount) {
            errors.amount = 'Amount cannot be greater than Outstanding Amount';
        } else {
            errors.amount = '';
        }
        setErrors(errors);
    }, [amount, totalAmount]);

    const validate_create_payment = () => {
        const newErrors = {};
        if(!amount) {
            newErrors.amount = 'This Field is Required.';
        }
        if(!collectedDate) {
            newErrors.date = 'This Field is Required.';
        }
        
        return newErrors;
    };

    const create_partial_payment = (event) => {
        event.preventDefault();

        const validationErrors = validate_create_payment();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const params = {
            branch_id: branch_id,
            subscriber_id: data.subscriber,
            subscription_id: data.subscription_id,
            total_amount: amount,
            created_by: user_id,
            status: 0,
            payment_schedule_date: collectedDate
        };
        axios.post(`${baseURL}/subscription/create_partial_payment`, params)
            .then(response => {
                fetchData();
                fetchBalance();
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                
            });
    };

    const [selectedPay, setSelectedPay] = useState({});

    const urldata = {
        order_id: selectedPay?.sno,
        amount: selectedPay?.total_amount
    };
    const encoded = btoa(JSON.stringify(urldata));

    const [submitDate, setSubmitDate] = useState(null);
    const handleSubmitDateChange = (date) => {
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            // console.log(formattedDate);
            setSubmitDate(formattedDate);
        } else {
            setSubmitDate(null);
        }
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if(!sendVia) {
            newErrors.mode = 'This Field is Required.';
        }
        if (sendVia === 'offline') {
            if(!submitDate) {
                newErrors.subdate = 'This Field is Required.';
            }
        }
        
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        
        const postData = {
            payment_mode: sendVia === 'offline' ? 1 : 0,
            payment_id: selectedPay?.sno,
            date: submitDate,
            amount: selectedPay?.total_amount,
            user_id: user_id,
        }

        axios.post(`${baseURL}/subscription/verify_offline_payment`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Payment Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Payment Updation Failed");
            });
    };

    return (
         <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Subscription Payment</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-1">
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Subscriber</label>
                            <label className='text-primary fs-6 font-w500'>{data.lead_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Mobile No</label>
                            <label className='text-primary fs-6 font-w500'>{data.lead_mobile_no}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Product</label>
                            <label className='text-primary fs-6 font-w500'>{data.product_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Timeline</label>
                            <label className='text-primary fs-6 font-w500'>{data.timeline_name} ({data.timeline_days} Days)</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Days</label>
                            <label className='text-primary fs-6 font-w500'>
                                {timelinerelation.all_days === 0
                                    ? 'All'
                                    : [
                                        timelinerelation.monday === "0" && 'Mon',
                                        timelinerelation.tuesday === "0" && 'Tue',
                                        timelinerelation.wednesday === "0" && 'Wed',
                                        timelinerelation.thursday === "0" && 'Thu',
                                        timelinerelation.friday === "0" && 'Fri',
                                        timelinerelation.saturday === "0" && 'Sat',
                                        timelinerelation.sunday === "0" && 'Sun',
                                    ]
                                    .filter(Boolean)
                                    .join(', ')
                                }
                            </label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Package Amount</label>
                            <div>
                                <Badge bg="info" className='text-white fs-6 py-0 px-1'>
                                    <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                    <span>{packagerelation.selling_amount}</span>
                                </Badge>
                            </div>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-black font-w600 fs-7'>Duration</label>
                            <div className="font-w500 fs-6">
                                <label className="text-success font-w500 fs-6">{formatDate(data.start_date)}</label>
                                <label className="text-black font-w500 fs-6 ms-1 me-1">/</label>
                                <label className="text-danger font-w500 fs-6">{formatDate(data.end_date)}</label>
                            </div>
                        </div>
                    </div>

                    {/* old payment */}
                        <div className="row mb-3 d-none">
                            <div className='col-lg-6'>
                                <div className='text-center mb-4'>
                                    <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                        <label className='mb-0'>Transaction Details</label>
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-lg-12 mb-4'>
                                        <label className="text-black font-w500 fs-7">Payment Mode<span className="required">*</span></label>
                                        <Select
                                            placeholder="Select Payment Mode"
                                            options={paymentmode}
                                            menuPlacement='top'
                                            onChange={handlePaymentChange}
                                        />
                                        {errors.payment && <div className="text-danger fs-8 mt-1">{errors.payment}</div>}
                                    </div>
                                    {isVisible && (
                                        <div className="col-lg-12 mb-4">
                                            <label className="text-black font-w500 fs-7">Transaction ID<span className="required">*</span>
                                            </label>
                                            <input type="text" className="form-control" placeholder="Enter Transaction ID" 
                                                maxLength={500}
                                                value={transactionId} 
                                                onChange={(e) => setTransactionId(e.target.value)} 
                                            />
                                            {errors.transactionId && <div className="text-danger fs-8 mt-1">{errors.transactionId}</div>}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className='text-center mb-4'>
                                    <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                        <label className='mb-0'>Payments Details</label>
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                        <div className='text-black font-w500 fs-4'>Sub Total</div>
                                        <div>
                                            <label className='text-black font-w500 fs-3'>
                                                <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                <span>{isNaN(subtotal) ? '0' : subtotal}</span>
                                            </label>
                                        </div>
                                    </div>
                                    
                                    

                                    <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                        <div className='text-black font-w500 fs-5'>
                                            <label className='text-black font-w500 fs-5'>GST</label>
                                            <label className='text-danger font-w600 fs-5 ms-1'>( 5% )</label>
                                        </div>
                                        <div className='text-black font-w500 fs-4'>
                                            <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                            <label className='text-black font-w500 fs-4'>{isNaN(gst) ? '0' : gst}</label>
                                        </div>
                                    </div>

                                    <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                        <label className='text-black font-w500 fs-3'>Total Amount</label>
                                        <div>
                                            <label className='text-danger fw-bold fs-2'>
                                                <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                <span>{isNaN(totalAmount) ? '0' : totalAmount}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/* old payment */}

                    {balance_amount > 0 && (
                        <div className="col-lg-12 mb-4">
                            <div className="col-lg- rounded p-3 bg-light">
                                <h5 className="mb-3 text-black">Make Partial Payment</h5>
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <label className="form-label fw-bold text-black">Outstanding Amount</label>
                                        <input type="text" className="form-control text-black" disabled value={balance_amount}/>
                                        <div style={{ height: "1.25rem", marginTop: "0.25rem" }}></div>
                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label fw-bold text-black">Payment Amount</label>
                                        <input type="text" className="form-control text-black"
                                            placeholder={`Max: ₹ ${balance_amount}`}
                                            maxLength={10}
                                            value={amount} 
                                            onChange={(e) => {
                                                let onlyNums = e.target.value.replace(/[^0-9.]/g, '');
                                                const parts = onlyNums.split('.');
                                                if (parts.length > 2) {
                                                    onlyNums = parts[0] + '.' + parts.slice(1).join('');
                                                }
                                                setAmount(onlyNums);
                                            }}
                                        />
                                        {errors.amount && <span className='text-danger'>{errors.amount}</span>}
                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label fw-bold text-black">Payment Schedule Date<span className="required">*</span></label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker placeholder='Select Date'
                                                minDate={new Date().setHours(0, 0, 0, 0)}
                                                maxDate={addDays(new Date(), 7)}
                                                format="DD-MM-YYYY"
                                                onChange={handleCollectDateChange}
                                            />
                                        </div>
                                        {errors.date && <span className='text-danger'>{errors.date}</span>}
                                    </div>

                                    <div className="col-md-3 d-flex flex-column justify-content-end">
                                        <button className="btn btn-primary fs-7 w-100" onClick={create_partial_payment}>Create Payment</button>
                                        <div style={{ height: "1.25rem", marginTop: "0.25rem" }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    
                    <div className="row mb-3">

                        {paymentdatas.length > 0 && (
                            <div className='col-lg-12 mb-4'>
                                <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className="text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-80px'>Schedule Date</th>
                                            <th className='min-w-80px'>Payment Amount  </th>
                                            <th className='min-w-80px'>Payment Date </th>
                                            <th className='min-w-80px'>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                        {paymentdatas.map((data, index) => (
                                            <tr className='align-items-center'>
                                                <td>
                                                    <label className='text-black font-w600 fs-7 mt-3'>{formatDate(data.payment_schedule_date)}</label>
                                                </td>
                                                <td>                                
                                                    <label className='text-black font-w600 fs-7 mt-3'>₹ {data.total_amount}</label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w600 fs-7  mt-3'>{data.status === 1 ? formatDate(data.initialPayDate) : '-'}</label>
                                                </td>
                                                <td>
                                                    {data.status === 0 ? (
                                                        <label className='text-white font-w600 fs-7 bg-primary py-1 px-2 rounded  mt-2' style={{ cursor: 'pointer' }} onClick={() => {setShowPaymentDetails(true); setSelectedPay(data);}}>
                                                            Pay
                                                        </label>
                                                    ):(
                                                        <label className='text-white font-w600 fs-7 bg-success py-1 px-2 rounded  mt-2' >
                                                            Paid
                                                        </label>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        
                        {showPaymentDetails && (
                        <>
                            <div className='col-lg-12 mb-2'>
                                <div className='text-center mb-4'>
                                    <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                        <label className='mb-0'>Payments Details</label>
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-lg-6 mb-2'>
                                        <div className='row mb-2'>
                                            {/* Radio Buttons */}
                                            <div className="col-lg-12 mb-4">
                                                <label className="text-black font-w500 fs-5">Payment Mode<span className="required">*</span></label>
                                                <div className='mt-2'>
                                                    <div className="form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="send_via"
                                                            value="online"
                                                            checked={sendVia === 'online'}
                                                            onChange={handleSendViaChange}
                                                        />
                                                        <label className="form-check-label fs-7 font-w600 text-black">Online</label>
                                                    </div>
                                                    <div className="form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="send_via"
                                                            value="offline"
                                                            checked={sendVia === 'offline'}
                                                            onChange={handleSendViaChange}
                                                        />
                                                        <label className="form-check-label fs-7 font-w600 text-black">Offline</label>
                                                    </div>
                                                </div>
                                                <span className='text-danger'>{errors.mode}</span>
                                            </div>
                                            {sendVia === 'online' && (
                                                <>
                                                <div className='col-lg-12 mb-2'>
                                                    <Link to={`/subscription_payment?data=${encodeURIComponent(encoded)}`} target="_blank" rel="noopener noreferrer">
                                                        <div className='d-flex align-items-center gap-2 rounded py-1 px-2' style={{ backgroundColor: '#dafcc7ff' }} >
                                                            <i className="fa-solid fa-link text-primary fs-4"></i>
                                                            <label className='text-primary font-w600 fs-5 ms-1'>Link attached</label>
                                                        </div>
                                                    </Link>
                                                </div>

                                                <div className='col-lg-12 mb-2 text-center'>
                                                    <QRCodeSVG
                                                    value={`/subscription_payment?data=${encodeURIComponent(encoded)}`}
                                                    size={200}
                                                    bgColor="#ffffff"
                                                    fgColor="#000000"
                                                    level="H"
                                                    includeMargin={true}
                                                    />
                                                </div>
                                                </>
                                            )}
                                            {sendVia === 'offline' && (
                                                <>
                                                    <div className="col-lg-6 mb-4">
                                                        <label className="text-black font-w500 fs-7">Amount Collected<span className="required">*</span></label>
                                                        <input type="text" className="form-control" placeholder="Enter Amount" value={selectedPay.total_amount} disabled />
                                                    </div>
                                                    
                                                    <div className="col-lg-6 mb-3">
                                                        <label className="text-black font-w500 fs-7">Collected Date<span className="required">*</span></label>
                                                        <div className='datepicker-wrapper d-flex'>
                                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                            <DatePicker placeholder='Select Date'
                                                                minDate={subDays(new Date(), 7)}
                                                                maxDate={new Date().setHours(23, 59, 59, 999)}
                                                                format="DD-MM-YYYY"
                                                                onChange={handleSubmitDateChange}
                                                            />
                                                        </div>
                                                        <span className='text-danger'>{errors.subdate}</span>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 mb-2'>
                                        <div className='row mb-2'>
                                            <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                <div className='text-black font-w500 fs-4'>Sub Total</div>
                                                <div>
                                                    <label className='text-black font-w500 fs-3'>
                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                        <span>{selectedPay.total_amount}</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                                <label className='text-black font-w500 fs-3'>Total Amount</label>
                                                <div>
                                                    <label className='text-danger fw-bold fs-2'>
                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                        <span>{selectedPay.total_amount}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        )}
                    </div>
                    
                    {showPaymentDetails && (
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            <Link className="btn btn-sm btn-primary" onClick={handleSubmit}>Submit Payment<i className="fas fa-angle-double-right ms-2"></i></Link>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default SubscriptionPayment;
